import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Layer,
  Loading,
  Pane,
  PaneFooter,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import FormFields from './FormFields';

const propTypes = {
  localizedName: PropTypes.string,
  onClose: PropTypes.func,
  initialValues: PropTypes.object,
  onHandleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
};

function DefaultFieldsForm({
  localizedName,
  onClose,
  initialValues,
  onHandleSubmit,
  isLoading,
}) {
  const renderPaneFooter = (submit, pristine, submitting) => {
    return (
      <PaneFooter
        renderEnd={
          <Button
            buttonStyle="mega primary"
            disabled={pristine || submitting}
            id="default-fields-form-pane-footer-submit-btn"
            marginBottom0
            type="submit"
            onClick={(event) => {
              submit(event);
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            <FormattedMessage
              id="stripes-components.saveAndClose"
              defaultMessage="Save and close"
            />
          </Button>
        }
        renderStart={
          <Button
            buttonStyle="mega primary"
            id="default-fields-form-pane-footer-cancel-btn"
            marginBottom0
            onClick={onClose}
          >
            <Icon icon="times-circle-solid">
              <FormattedMessage
                id="stripes-components.cancel"
                defaultMessage="Cancel"
              />
            </Icon>
          </Button>
        }
      />
    );
  };

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, pristine, submitting, values }) => {
        return (
          <form
            id="default-fields-form"
            onSubmit={handleSubmit}
          >
            <Layer contentLabel="Edit inventory default field" isOpen>
              <Pane
                id="inventory-templates-plugin-default-fields-form-pane"
                defaultWidth="fill"
                paneTitle={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFieldsForm.edit.pane.paneTitle"
                    values={{ defaultField: localizedName }}
                    defaultMessage="Edit {defaultField} field"
                  />
                }
                dismissible
                onClose={onClose}
                footer={renderPaneFooter(handleSubmit, pristine, submitting)}
              >
                {isLoading && <Loading size="large" />}

                {!isLoading && <FormFields />}
                <hr />
                <pre>{JSON.stringify(values, 0, 2)}</pre>
              </Pane>
            </Layer>
          </form>
        );
      }}
    </Form>
  );
}

DefaultFieldsForm.propTypes = propTypes;

export default DefaultFieldsForm;
